"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const ShowFiltersButton_1 = __importDefault(require("./ShowFiltersButton"));
const ShowAnalyticsButton_1 = __importDefault(require("./ShowAnalyticsButton"));
const SaveButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    // @ts-ignore
    color: theme?.palette?.primary?.brown,
}));
const AdvancedSearchToolbar = ({ onFilterToggleClick, onSaveSearchClick, onShowAnalyticsClick, showFilterColumns = false, showAnalytics = false, disableSave, enableAnalytics = false, }) => (react_1.default.createElement(material_1.Toolbar, null,
    enableAnalytics ? (react_1.default.createElement(ShowAnalyticsButton_1.default, { isShown: showAnalytics, onClick: onShowAnalyticsClick })) : null,
    react_1.default.createElement(SaveButton, { onClick: onSaveSearchClick, disabled: disableSave }, "Save Search"),
    react_1.default.createElement(ShowFiltersButton_1.default, { onClick: onFilterToggleClick, isShown: showFilterColumns })));
exports.default = AdvancedSearchToolbar;
